import deepFreeze from 'deep-freeze';

export const MODEL_NAME = Object.freeze({
  SINGULAR: 'patientSignature',
  PLURAL: 'patient-signatures',
});

export const FIELD_NAME = Object.freeze({
  ID: 'id',
});

export const SCHEMA = deepFreeze({
  title: MODEL_NAME.SINGULAR,
  type: 'object',
  properties: {
    [FIELD_NAME.ID]: {
      type: 'string',
    },
  },
});
